/**
 * Navigation
 */
import {
	debounce,
	getRootVar
} from '@ifabnpm/bootstrap/utils.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';

import Nav from '@ifabnpm/bootstrap/component/nav.js';
import Drawer from '@ifabnpm/bootstrap/component/drawer.js';

// -------
// Private
// -------

const NAME      = 'menu';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY    = '.data-api';

const pageMenu = SelectorEngine.findOne('#page-menu-drawer');

let nav;
let mainNavInstance;

/**
 * Drawer (Navigationsoverlay)
 */
const setupDrawer = () => {
	const triggers = SelectorEngine.find('[aria-controls="page-menu-drawer"]');
	const drawer  = new Drawer(pageMenu, {
		closeButton : false,
		placement: 'top',
		// onInit   : (event) => {
		// 	const componentCloseButton = SelectorEngine.findOne('.drawer__header > .drawer-close', event.target);
		//
		// 	if (componentCloseButton) {
		// 		componentCloseButton.remove();
		// 	}
		// },
		onShow   : function() {
			for (const element of triggers) {
				Manipulator.addClass(element, '_active');
			}
		},
		onHidden : () => {
			for (const element of triggers) {
				Manipulator.removeClass(element, '_active');
			}
		}
	});

	for (const element of triggers) {
		EventHandler.on(element, 'click.ifab.pageMenuDrawer', (event) => {
			event.preventDefault();
			event.stopPropagation();

			if (event.delegateTarget.classList.contains('_active')) {
				drawer.hide();
			} else {
				drawer.show();
			}
		});
	}
};

const navigationToggleLayout = () => {
	const targetWidth = parseInt(getRootVar(`${window.pageInstance.prefix}breakpoint-l`), 10) ?? 0;

	if (targetWidth) {
		const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

		if (screenWidth < targetWidth) {
			mainNavInstance.hideAll();
			mainNavInstance.showCurrentTree();

		} else {
			mainNavInstance.showAll();
		}
	}
};

/**
 * Initialisierung der eigentlichen Navigationsliste.
 */
const navigation = () => {
	nav = SelectorEngine.findOne('#main-nav');

	if (nav) {
		mainNavInstance = new Nav(nav, {
			closeByOutsideClick: false,
			closeByEsc         : false,
			labelSubmenu       : (window.pageInstance.tm) ? window.pageInstance.tm.translate('ariaLabelSubmenu') : 'Submenu for %s',
			labelSubmenuTrigger: (window.pageInstance.tm) ? window.pageInstance.tm.translate('ariaLabelSubmenuTrigger') : 'Show submenu for %s',
			useReveal          : {
				visibleDisplay: 'block'
			},
			leaveOpen : true,
			onHide             : () => {
				// Manipulator.addClass(event.relatedMenu, '-will-hide');
			},
			onHidden           : () => {
				// Manipulator.removeClass(event.relatedMenu, '-will-hide');
			},
			onShow             : () => {
				// Manipulator.addClass(event.relatedMenu, '-will-show');
			},
			onShown            : () => {
				// Manipulator.removeClass(event.relatedMenu, '-will-show');
			}
		});

		// const curPageItem = SelectorEngine.findOne('[aria-current="page"]');
		//
		// if (appMenuBody && curPageItem) {
		// 	scrollElementIntoView(curPageItem, appMenuBody, 'vertical');
		// }

		// Menütyp bestimmen/erkennen & überwachen.
		navigationToggleLayout();
		window.addEventListener('resize', debounce(navigationToggleLayout, 300));
		window.addEventListener('orientationchange', debounce(navigationToggleLayout, 300));
	}
};

// -------
// Public
// -------

const menu = () => {
	if (pageMenu) {
		setupDrawer();
		navigation();
	}
};

// Export
export default menu;
